<template>
  <div class="content work_flow_wrap" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="tab-wrap">
      <el-tabs v-model="page.listType" @tab-click="onTabClick">
        <el-tab-pane label="全部流程" name="0"> </el-tab-pane>
        <el-tab-pane label="待处理" name="4"></el-tab-pane>
        <el-tab-pane label="我审批的" name="2"></el-tab-pane>
        <el-tab-pane label="我收到的" name="3"></el-tab-pane>
        <el-tab-pane label="我发起的" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search-area pt0">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">公司名称：</div>
          <el-select  size="mini" filterable clearable v-model="page.tenantGuid" class="ipt-sty" placeholder="请选择" >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">报告名称：</div>
          <el-input v-model="page.reportName" class="ipt-sty" placeholder="请输入" clearable></el-input>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">审批状态：</div>
          <el-select :disabled="page.listType==3||page.listType==4"  size="mini" filterable clearable v-model="page.approveState" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in approveStateOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
    
    
        <el-col :span="6">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button></el-col
        >
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">审批时间：</div>
          <el-date-picker
            size="mini"
            v-model="timeListS"
            type="daterange"
            range-separator="至"
            class="ipt-sty"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">提交人：</div>
          <el-input v-model="page.applyStaffName" class="ipt-sty" placeholder="请输入" clearable></el-input>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">流程编号：</div>
          <el-input v-model="page.flowNo" class="ipt-sty" placeholder="请输入" clearable></el-input>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff content-main-box"   :style="'height:' + contentMainHeight + 'px'">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="$router.push('/marketTzEdit')">申请市场拓展规划方案</el-button>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="tableHeight">
        <el-table-column label="序号" width="50" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="left"
          prop="flowNo"
          label="流程编号"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="110"
        >
  
          <template slot-scope="scope">{{ scope.row.approveVO.flowNo || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="bizTenantName"
          label="公司名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="180"
        >
          <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="flowName"
          label="报告名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="250"
        >
          <template slot-scope="scope">{{ scope.row.reportName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="endTime" label="审批状态" header-align="center" align="center" width="100">
          <template slot-scope="scope"
            ><span :class="getStateShow(scope.row.approveVO.approveState)">{{
              scope.row.approveVO.approveState | approveState
            }}</span></template
          >
        </el-table-column>
    
        <el-table-column prop="staffName" label="提交人" header-align="center" align="left" width="120">
          <template slot-scope="scope">{{ scope.row.applyStaffName || '-' }}</template>
        </el-table-column>
      
        <el-table-column
          prop="accountMonthName"
          label="推广月份"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ scope.row.expandMonth || '-' }}</template>
        </el-table-column>
    
        <el-table-column
          prop="createTime"
          label="提交时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">{{ scope.row.submitTime | getTime }}</template>
        </el-table-column>
        <el-table-column prop="approveTime" label="操作时间" header-align="center" align="left" width="140">
          <template slot-scope="scope">{{ scope.row.approveVO.approveTime | getTime }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="200" label="操作" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <a
              class="txt-color"
              v-if="getListBtnState('detail', scope.row) == 'detail'"
              @click="editData(scope.row,3)"
            >
              详情
            </a>
            <a
              class="txt-color"
              @click="
                passDialogVisible = true;
                approveSuggest = '';
                form = scope.row;
              "
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              通过
            </a>
            <a
              class="txt-color"
              @click="
                rejectDialogVisible = true;
                approveSuggest = '';
                form = scope.row;
              "
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              驳回
            </a>
            <a class="txt-color" @click="toRevoke(scope.row)" v-if="getListBtnState('revoke', scope.row) == 'revoke'">
              撤销
            </a>
            <a class="txt-color" @click="editData(scope.row, 1)" v-if="getListBtnState('edit', scope.row) == 'edit'">
              编辑
            </a>
            <a class="txt-color" v-if="getListBtnState('del', scope.row) == 'del'" @click="delData(scope.row.guid)">
              删除
            </a>

            <a class="txt-color" v-if="getListBtnState('again', scope.row) == 'again' && scope.row.approveState != 'D'" @click="editData(scope.row, 2)">
              重新提交
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <!-- 打印 -->
    <!-- <PassDialog :flowType="form.flowType" @passSuccess="getList(1)" ref="pass" ></PassDialog> -->
  </div>
</template>
  
  <script>
  import { route } from '@/api/apiRoute';
  import store from '@/store';
  import workFlowCommon from '@/uilt/workFlowCommon';
//   import PassDialog from './components/passDialog.vue';
  export default {
    components:{
     // PassDialog
    },
    data() {
      let userinfo = JSON.parse(localStorage.userInfo);
      return {
        tableLoading:false,
        tableHeight: window.innerHeight - 310,
        contentMainHeight: window.innerHeight - 240,
        showMore: false, // 筛选项显示更多，默认否，最多显示三个
        fullscreenLoading:false,
        tenantList:[],
        page: {
          staffGuid:userinfo.staffGuid,
          tenantGuid: null,
          flowType: '00027',
          pageSize: 50,
          pageIndex: 1,
          applyStaffName: null,
          listType: '0',
          approveState: null,
          flowNo: null,
        },
        timeListS: [],
        tableData: [],
        approveSuggest: '',
        passDialogVisible: false,
        rejectDialogVisible: false,
        form: '',
        approveStateOption: [
          { label: '全部', value: '' },
          { label: '草稿中', value: 'N' },
          { label: '审批中', value: 'A' },
          { label: '已通过', value: 'Y' },
          { label: '已驳回', value: 'R' },
          { label: '已撤销', value: 'C' },
        ],
      };
    },
  
    created() {
      let userinfo = JSON.parse(localStorage.userInfo);
      this.currentStaffGuid = userinfo.staffGuid;
      this.getList();
      this.getTenantList();
    },
    activated(){
      this.getList();
    },
    watch: {
      showMore(val, oldVal) {
        if (val) {
            this.tableHeight = window.innerHeight - 350;
            this.contentMainHeight = window.innerHeight - 270;
            return;
        }
        if (!val) {
            this.tableHeight = window.innerHeight - 310;
            this.contentMainHeight = window.innerHeight - 240;
            return;
        }
      },
    },
    methods: {
      onTabClick() {
        // if (this.page.listType == 3) {
        //   this.page.approveState = 'Y'
        // }else if (this.page.listType == 4) {
        //   this.page.approveState = 'A'
        // } else {
        //   this.page.approveState = null;
        // }
        this.getList();
      },
      //获取操作按钮显隐
      getListBtnState(btnType, row) {
        let approveVO = row.approveVO;
        console.log(approveVO)
        return workFlowCommon.getListBtnState(
          btnType,
          approveVO.approveState,
          approveVO.staffGuid,
          approveVO.approveStaffGuids,
          this.currentStaffGuid,
          row.bizApproveState,
        );
      },
      //获取审批状态
      getStateShow(approvalState) {
        return workFlowCommon.getStateClass(approvalState);
      },
      //获取药企
      getTenantList(val) {
        let self = this;
        let query ={
          'pageIndex':1,
          'pageSize':-1,
          'bizState':'Y',
          'enterpriseCates':this.$getValueListByKey('上游客户分类')
        }
        self.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation`,query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.tenantList = res.data.data.records || [];
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },

      //清空
      emptySearch() {
        let userinfo = JSON.parse(localStorage.userInfo);
        this.page = {
          tenantGuid: null,
          flowType: '00027',
          pageSize: 50,
          pageIndex: 1,
          applyStaffName: null,
          listType: '0',
          approveState: null,
          flowNo: null,
          staffGuid:userinfo.staffGuid
        };
        this.timeListS = [];
        this.getList(1);
      },
      delData(guid) {
        let self = this;
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            self.api.postJson(`/${serverConfig.msSalesPerformService}/market-expand-plan/del`, [guid]).then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                this.getList(1);
              } else {
                self.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
      },
      //type 为1编辑 2重新提交 3为详情
      editData(row, type) {
        this.$router.push({
          path: (type == 1 || type == 2) ? 'marketTzEdit' : 'marketTzDetail',
          query: {
            guid: row.guid,
            type: type,
            camundaInstanceId: row.approveVO.camundaInstanceId,
            camundaDeploymentId: row.approveVO.camundaDeploymentId
          }
        });
      },
      getList(type) {
        let self = this;
        if (type == 1) {
          self.page.pageIndex = 1;
        }
        //日期处理 开始时间 结束时间
        if (
          self.timeListS &&
          Array.isArray(self.timeListS) &&
          self.timeListS.length > 0 &&
          self.timeListS[0] &&
          self.timeListS[1]
        ) {
          self.page.startApproveTime = self.$moment(self.timeListS[0]).format('YYYY-MM-DD HH:mm:ss');
          self.page.endApproveTime = self.$moment(self.timeListS[1]).format('YYYY-MM-DD 23:59:59');
        } else {
          self.page.startApproveTime = '';
          self.page.endApproveTime = '';
        }
        let req = JSON.parse(JSON.stringify(this.page));
        req.approveStateList = req.approveState?[req.approveState]:null;
        self.tableLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/market-expand-plan/page-list`,req).then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.records || [];
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },

      //驳回提交
      toRejectSubmit() {
        let userinfo = JSON.parse(localStorage.userInfo);
        if (this.approveSuggest == '') {
          this.$message.error('请填写驳回理由！');
          return;
        }
        let query = {
          guid: this.form.approveVO.approveGuid,
          flowType: this.form.approveVO.flowType,
          approveSuggest: this.approveSuggest,
          approveStaffGuid: userinfo.staffGuid,
        };
        this.fullscreenLoading = true;
  
        this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.rejectDialogVisible = false;
            this.$message.success('驳回成功！');
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      //通过
      toPassSubmit() {
        let userinfo = JSON.parse(localStorage.userInfo);
        let query = {
          guid: this.form.approveVO.approveGuid,
          flowType: this.form.approveVO.flowType,
          approveSuggest: this.approveSuggest,
          approveStaffGuid: userinfo.staffGuid,
        };
        this.fullscreenLoading = true;
        this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.passDialogVisible = false;
            this.$message.success('审批通过！');
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      //撤销
      toRevoke(form) {
        let self = this;
        this.$confirm('确定撤销吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            let query = {
              guid: form.approveVO.approveGuid,
              flowType: form.approveVO.flowType,
              approveStaffGuid: form.approveVO.staffGuid,
            };
            self.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.fullscreenLoading = false;
                self.$message.success('撤销成功！');
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {
            self.$message({
              type: 'info',
              message: '已取消操作！',
            });
          });
      },
      handleSizeChange(val) {
        let self = this;
        self.page.pageSize = val;
        this.getList();
      },
      handleCurrentChange(val) {
        let self = this;
        self.page.pageIndex = val;
        this.getList();
      }
    },
  };
  </script>
  <style scoped>
  .el-table /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
  }
  /deep/ .el-checkbox__label {
    display: none;
  }
  .attach-sty {
    width: 170px;
    float: left;
    margin-top: 15px;
    text-align: center;
  }
  .checkbox-img-sty {
    border: 1px solid #dcdfe6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
  }
  /deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color: #4fa1a4;
    border-color: inherit;
  }
  /deep/ .el-step__icon-inner {
    color: #4fa1a4;
  }
  /deep/ .el-step__title.is-process {
    color: #4fa1a4;
  }
  .el-col-6,
  .el-col-9 {
    display: flex;
    /* margin-bottom: 10px; */
  }
  .ipt-sty {
    flex: 1;
  }
  /deep/ .el-input__prefix {
    top: -4px !important;
  }
  a.txt-color + a.txt-color::before {
    content: '|';
    display: inline-block;
  }
  .flow-dialog {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  .flow-dialog .flow-item {
    width: 90%;
    font-weight: bold;
    width: 200px;
    padding: 25px 0;
    text-align: center;
    border: 1px solid rgba(235, 235, 235, 1);
    border-radius: 4px;
    cursor: pointer;
  }
  .flow-dialog .flow-item:hover {
    color: #fff;
    background: #4fa1a4;
  }
  .flow-item-active {
    color: #fff;
    background: #4fa1a4;
  }
  .flow-dialog-title {
    position: relative;
    text-align: left;
    margin-top: 0;
  }
  .flow-dialog-title .flow-dialog-line {
    position: absolute;
    top: -3px;
    display: inline-block;
    width: 4px;
    height: 24px;
    background: #4fa1a4;
  }
  .flow-dialog-title .flow-dialog-txt {
    display: inline-block;
    padding-left: 15px;
  }
  .search-area-div{
    width: 90px;
    text-align: right;
  }
  .tab-wrap {
    background: #fff;
  
  }
  
  /deep/ .el-tabs__nav {
    margin-left: 10px;
  }
  </style>
  